(function () {
  function initCarousel(root) {
    var track = root.querySelector('.asr__track');
    if (!track || root.dataset.asrInit) return;
    root.dataset.asrInit = '1';
    var prev = root.querySelector('.asr__prev');
    var next = root.querySelector('.asr__next');
    function step() { var c = track.querySelector('.asr__card'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function scrollable() { return track.scrollWidth - track.clientWidth > 5; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 5; }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    var timer = null;
    function start() { if (timer || !scrollable()) return; timer = setInterval(function () { if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' }); }, 4000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }
  function initFilters(root) {
    if (root.dataset.aarInit) return;
    root.dataset.aarInit = '1';
    var buttons = root.querySelectorAll('.aar__filter');
    var cards = root.querySelectorAll('.aar__card');
    var noRes = root.querySelector('.aar__noresults');
    function apply(f) {
      var v = 0;
      cards.forEach(function (card) {
        var s;
        if (f === 'all') s = true;
        else if (f === 'product' || f === 'store') s = card.getAttribute('data-type') === f;
        else if (f === 'photo') s = card.getAttribute('data-photo') === 'true';
        else s = card.getAttribute('data-rating') === f;
        card.style.display = s ? '' : 'none';
        if (s) v++;
      });
      if (noRes) noRes.hidden = v !== 0;
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        apply(btn.getAttribute('data-filter'));
      });
    });
  }
  function init() {
    document.querySelectorAll('.asr').forEach(initCarousel);
    document.querySelectorAll('.aar').forEach(initFilters);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
